import React from 'react'

// form fields
// import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'

export default function ShippingRates(props) {
    // props
    // const { formik } = props


    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* heading */}
                    <p className="box-heading st-fs-18 st-fw-600 st-text-color mb-2">Shipping Rates</p>


                    <div className="shipping-rates-form-items">
                        {/* radio */}
                        <label className="st-custom-radio d-flex">
                            <input type="radio" className="d-none" name="item" />
                            <span className="round"><span className="inner"></span></span>
                            {/* text */}
                            <span className="text media-body">
                                <span className="head d-block st-fw-600 mb-1">Use your store's shipping methods</span>
                                <span className="desc d-block st-fs-13">
                                    shipping for this product is set according to <a href="#" className="hover-underline-link st-text-primary">Shipping Settings</a>.
                                    Shipping cost is calculated accordingly. Use this option if there are no special fees and conditions
                                    associated with delivery of this item. You can change a fixed fee per item quantity on top of the shipping cost. <br />
                                    <a href="#" className="hover-underline-link st-text-primary">Add Fixed fee per item</a>
                                </span>
                            </span>
                        </label>

                        {/* radio */}
                        <label className="st-custom-radio d-flex">
                            <input type="radio" className="d-none" name="item" />
                            <span className="round"><span className="inner"></span></span>
                            {/* text */}
                            <span className="text media-body">
                                <span className="head d-block st-fw-600 mb-1">Specify shipping methods for this product</span>
                                <span className="desc d-block st-fs-13">
                                    Customize the list of shipping methods available for this product. White-list methods by adding them to the enable list.
                                    Excludes specific methods by adding them to the disable list.
                                </span>
                            </span>
                        </label>

                        {/* radio */}
                        <label className="st-custom-radio d-flex">
                            <input type="radio" className="d-none" name="item" />
                            <span className="round"><span className="inner"></span></span>
                            {/* text */}
                            <span className="text media-body">
                                <span className="head d-block st-fw-600 mb-1">Fixed rate per item</span>
                                <span className="desc d-block st-fs-13">
                                    Charge a fixed fee per item quantity. Use this option if this product requires individual shipping price.
                                </span>
                            </span>
                        </label>

                        {/* radio */}
                        <label className="st-custom-radio d-flex">
                            <input type="radio" className="d-none" name="item" />
                            <span className="round"><span className="inner"></span></span>
                            {/* text */}
                            <span className="text media-body">
                                <span className="head d-block st-fw-600 mb-1">Free Shipping</span>
                                <span className="desc d-block st-fs-13">
                                    Free shipping of the product in any quantity. Free of charge shipping is proven to encourage buy more and increase sales.
                                    Choose this option if you are going to cover shipping expenses yourself.
                                </span>
                            </span>
                        </label>
                    </div>

                </div>
            </div>
        </React.Fragment>
    )
}
